module.exports = __webpack_public_path__ + "img/zeroTwo.28eb46d1.png";